module.exports = __webpack_public_path__ + "static/media/colombia.efd145e1.svg";